const CATEGORY_COLORS: Record<string, string> = {
  person: "#A7F3D0",
  event: "#FDE68A",
  war: "#FECACA",
  invention: "#DDD6FE",
  dynasty: "#A7F3D0",
  monarch: "#A7F3D0",
  culture: "#FBCFE8",
  kingdom: "#C7D2FE",
};

const DEFAULT_COLOR = "#CBD5E1";

export const getCategoryColor = (categories: string[]): string => {
  const first = categories[0]?.toLowerCase();
  if (!first) return DEFAULT_COLOR;
  return CATEGORY_COLORS[first] ?? DEFAULT_COLOR;
};
